import View from "core/view";
import PlayerAnim from "./player-anim";
import { HighscoreView, HighscoreUpdater } from "core/highscore";
import Settings from "settings";
export const Event = {
  StartGame: "game",
  StartEditor: "editor",
  ChooseLevel: "chooseLevel"
};
export default function StartView(element) {
  const view = View({
    element,
    events: Event
  });
  createTitle(view);
  const highscoreUpdater = HighscoreUpdater(HighscoreView(view.querySelector(".highscore")));
  const editorInfo = view.querySelector("#editor-info");
  const showEditorInfo = () => editorInfo.classList.remove("hidden");
  const chooserInfo = view.querySelector("#chooser-info");
  const showChooserInfo = () => chooserInfo.classList.remove("hidden");
  PlayerAnim(element);
  function onKeyDown(callback) {
    element.addEventListener("keydown", callback);
  }
  async function updateHighscore(result) {
    await highscoreUpdater.update(result);
  }
  return Object.assign(view, {
    onKeyDown,
    showEditorInfo,
    showChooserInfo,
    updateHighscore
  });
}
function createTitle(view) {
  const {
    title
  } = Settings.app;
  const titleElement = view.querySelector("#title_animation");
  title.split("").forEach((letter, index) => {
    titleElement.appendChild(createTitleLetter(letter, index));
  });
}
function createTitleLetter(letter, index) {
  const {
    titleAnimationDelay
  } = Settings.app;
  const span = document.createElement("span");
  span.classList.add("title_letter");
  span.textContent = letter;
  span.style.animationDelay = `${index * titleAnimationDelay}s`;
  return span;
}